import { render, staticRenderFns } from "./OwnerSettlements.vue?vue&type=template&id=1af18038&scoped=true&lang=pug"
import script from "./OwnerSettlements.vue?vue&type=script&lang=js"
export * from "./OwnerSettlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af18038",
  null
  
)

export default component.exports